import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import { useHistory,useParams,Link } from 'react-router-dom';
import Loading from '../../Components/Loading';
const FacultyAssignment = () => {
  const store = useSelector((store) => store);
  const history = useHistory();
  const { studentId } = useParams();
  const student = useSelector((store) => {
    return store.faculty.allStudent.find((student) => student._id === studentId);
  });
  if (!student) {
    return <div>Student not found</div>;
  }
  const isStudentDataAvailable = student.name && student.name.length > 0;

  return (
    <div>
      {store.faculty.isAuthenticated ? (
        <>
          <div className="container-fluid p-0">
            <div className="d-flex">
              <div className="print-helper">
                <FacultyHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                    <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                        <h5><Link to='/FacultyStudentControl' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                        <h3> <img src="/logo192.png" width={'50px'} alt="" /> {student.name}</h3>
                        <button  onClick={()=> window.print()} type="button" className="print-helper btn-success btn text-light"> <img src="/image/print.svg" lt="" /> <span className=''>Download</span></button>
                    </div>
                    <div className="col bg-light d-md-flex align-items-center justify-content-between">
                            <div className="stuData">
                                <div className="row">
                                    <div className='sortDetails overflow-hidden col-md-4'>
                                        <img className="img-fluid" width={'250px'} src={student.avatar} alt="Card image cap" />
                                        <h5 className='bg-dark text-light p-1 w-100'>{student.name}</h5>
                                        <div className="">
                                            <h6 className='d-flex align-items-center'>
                                                <img src="/image/mail.svg" alt="" className='p-1' />
                                                <span className="text-break">{student.email}</span>
                                            </h6>
                                            <h6 className='d-flex align-items-center'>
                                                <img src="/image/phone.svg" alt="" className='p-1' />
                                                <span className="text-break">{student.studentMobileNumber}</span>
                                            </h6>
                                            <h6 className={`badge badge-${student.status === 'active' ? 'success' : student.status === 'irregular' ? 'warning' : 'danger'}`}>
                                                {student.status}
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="table-responsive col-md-8">
                                        {isStudentDataAvailable ? (
                                        <table className="table shTable table-striped table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td>Name</td>
                                                    <td>{student.name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Email</td>
                                                    <td><small>{student.email}</small></td>
                                                </tr>
                                                <tr>
                                                    <td>Registration Number</td>
                                                    <td>{student.registrationNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td>Date Of Birth</td>
                                                    <td>{student.dob}</td>
                                                </tr>
                                                <tr>
                                                    <td>Year</td>
                                                    <td>{student.year}</td>
                                                </tr>
                                                <tr>
                                                    <td>Department</td>
                                                    <td>{student.department}</td>
                                                </tr>
                                                <tr>
                                                    <td>Section</td>
                                                    <td>{student.section}</td>
                                                </tr>
                                                <tr>
                                                    <td>Branch</td>
                                                    <td>{student.branch}</td>
                                                </tr>
                                                <tr>
                                                    <td>Gender</td>
                                                    <td>{student.gender ? student.gender : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Contact Number</td>
                                                    <td>{student.studentMobileNumber ?
                                                        student.studentMobileNumber : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Blood group</td>
                                                    <td>{student.bloodGroup ? student.bloodGroup : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>EMIS Number</td>
                                                    <td>{student.emisNumber ? student.emisNumber : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Religion</td>
                                                    <td>{student.Religion ? student.Religion : "NA"} </td>
                                                </tr>
                                                <tr>
                                                    <td>Community</td>
                                                    <td>{student.Community ? student.Community : "NA"} </td>
                                                </tr>
                                                <tr>
                                                    <td>Caste</td>
                                                    <td>{student.Caste ? student.Caste : "NA"} </td>
                                                </tr>
                                                <tr>
                                                    <td>Aadhar number</td>
                                                    <td>{student.aadharCard ? student.aadharCard : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>First graduate</td>
                                                    <td>{student.FirstGraduate ? student.FirstGraduate : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Special admission</td>
                                                    <td>{student.SpecialAdmission ? student.SpecialAdmission : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Permanent address</td>
                                                    <td ><small>{student.address ? student.address : "NA" }</small></td>
                                                </tr>
                                                <tr>
                                                    <td>Fathers name</td>
                                                    <td>{student.fatherName ? student.fatherName : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Fathers occupation</td>
                                                    <td>{student.fatherOccupation ? student.fatherOccupation : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Mother name</td>
                                                    <td>{student.motherName ? student.motherName : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Mother’s occupation</td>
                                                    <td>{student.MotherOccupation ? student.MotherOccupation : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Parent Contact Number</td>
                                                    <td>{student.fatherMobileNumber ? student.fatherMobileNumber : "NA"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Annual family income</td>
                                                    <td>{student.AnnualIncome ? student.AnnualIncome : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Bank account number</td>
                                                    <td>{student.BankAccountNumber ? student.BankAccountNumber : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>IFSC code</td>
                                                    <td>{student.IFSCcode ? student.IFSCcode : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Bank name</td>
                                                    <td>{student.BankName ? student.BankName : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Bank branch</td>
                                                    <td>{student.BankBranch ? student.BankBranch : "NA" }</td>
                                                </tr>

                                                <tr>
                                                    <td>Academic year of joining</td>
                                                    <td>{student.AcademicYear ? student.AcademicYear : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Date of admission</td>
                                                    <td>{student.DateOfadmission ? student.DateOfadmission : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Type of admission</td>
                                                    <td>{student.TypeOfAdmission ? student.TypeOfAdmission : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Counseling Number</td>
                                                    <td>{student.CounselingNumber ? student.CounselingNumber : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>lateral entry</td>
                                                    <td>{student.lateralEntry ? student.lateralEntry : "NA" }</td>
                                                </tr>
                                                <tr>
                                                    <td>Hosteller</td>
                                                    <td>{student.Hosteller ? student.Hosteller : "NA" }</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    ) : (
                                    <Loading />
                                        
                                    )}
                                </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
          </div>
        </>
      ) : (
        history.push('/')
      )}
    </div>
  );
};

export default FacultyAssignment;
